import {message, Modal} from 'antd';
import {
  AuthorizedUserAccessLevel,
  CreateAuthorizedUserInput,
  useCreateAuthorizedUserMutation
} from 'api/generated';
import {authorizedUsersQuery} from 'api/queries';
import {AnchorLink} from 'components';
import {Formik, FormikHelpers} from 'formik';
import React, {useState} from 'react';
import {useParams} from 'react-router-dom';
import {AuthorizedUserForm} from './AuthorizedUserForm';
import {StoresProps} from './AuthorizedUsers';

type Props = {
  disabled?: boolean;
} & StoresProps;

export const CreateUser: React.FC<Props> = ({stores, loadingStores, disabled}) => {
  const [isOpen, setOpen] = useState(false);
  const {accountId} = useParams<{accountId: string}>();
  const [createUser] = useCreateAuthorizedUserMutation({
    updateQuery: {
      query: authorizedUsersQuery,
      variables: {accountId}
    }
  });

  const handleSubmit = async (
    input: CreateAuthorizedUserInput,
    {setSubmitting, resetForm}: FormikHelpers<CreateAuthorizedUserInput>
  ) => {
    try {
      await createUser({variables: {input}});
      setOpen(false);
      message.success('An email is sent to the user with further instructions.');
      resetForm();
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <>
      <AnchorLink disabled={disabled} onClick={() => setOpen(true)}>
        Add new user
      </AnchorLink>
      <Formik<CreateAuthorizedUserInput>
        onSubmit={handleSubmit}
        initialValues={{
          userEmail: '',
          accountId,
          accessLevel: AuthorizedUserAccessLevel.READ_ACCESS
        }}>
        {({handleSubmit, isSubmitting, resetForm}) => (
          <Modal
            open={isOpen}
            title="Add new authorized user"
            okText="Add"
            cancelText="Cancel"
            confirmLoading={isSubmitting}
            onOk={() => handleSubmit()}
            onCancel={() => {
              setOpen(false);
              resetForm();
            }}>
            <AuthorizedUserForm stores={stores} loadingStores={loadingStores} />
          </Modal>
        )}
      </Formik>
    </>
  );
};
